export const isAuthenticated = (state) => {
  if (localStorage.getItem('token')) return true;
  return false;
};
